/* @flow */
import { Map } from 'immutable';
import * as ActionTypes from './action-types.js';
import type { NotificationPreferencesType, WatchedKeywordsType, WatchedKeywordType } from './types';

export const fetchPreferences = (): Object => ({ type: ActionTypes.FETCH_PREFERENCES });
export const updatePreferences = (notificationPreferences: NotificationPreferencesType): Object => ({ type: ActionTypes.UPDATE_PREFERENCES, payload: notificationPreferences });

export const fetchWatchedKeywords = (): Object => ({ type: ActionTypes.FETCH_WATCHED_KEYWORDS});
export const addWatchedKeyword = (keyword: WatchedKeywordType): Object => ({ type: ActionTypes.ADD_WATCHED_KEYWORD, payload: { keyword: keyword }});
export const deleteWatchedKeyword = (keyword: WatchedKeywordType): Object => ({ type: ActionTypes.DELETE_WATCHED_KEYWORD, payload: keyword});


// WEBPACK FOOTER //
// ./src/app/modules/notificationPreferences/actions.js